import { Component, Inject, Input, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ValidacionGeneracionRequerimientoService } from '../../../../services/validacion-generacion-requerimiento.service';
import { ButtonControlService } from '../../../../services/button-control.service';
import { DatosSeccionWizardEventsService } from '../../../../services/datos-seccion-wizard-events.service';
import { WIZARD_DATA } from '../../../../tokens/tokens';
import {PasoWizard} from "../../../../interface/wizard-informacion.types";
import {EvkSeccionModel} from '../../../../../expediente/models/evk-seccion.model';
import { CsrService } from '@evomatik/seaged-csr-library';
import * as uuid from 'uuid';

@Component({
  selector: 'lib-generacion-requerimiento',
  templateUrl: './generacion-requerimiento.component.html',
  styleUrls: ['./generacion-requerimiento.component.css']
})
export class GeneracionRequerimientoComponent implements OnInit {
  hide = true;
  hideConfirm = true;
  registerForm: FormGroup;
  submitted = false;
  valid = 'INVALID';
  @Input()
  config: PasoWizard;
  validData: boolean = true;
  errorGenerateCsr: boolean = false;
  showDownload: boolean = false;
  isDownload: boolean = false;
  userInfo: any = {};
  cer: any = {};

  constructor(
    private fb: FormBuilder,
    private customValidator: ValidacionGeneracionRequerimientoService,
    private buttonControlService: ButtonControlService,
    @Inject(WIZARD_DATA) public data: any,
    public datosSeccionWizard: DatosSeccionWizardEventsService,
    private csrService: CsrService,
  ) {
    console.debug("lib-generacion-requerimiento")
    const value = this.data?.paso?.inData?.expediente?.secciones?.filter((sec: any) => sec.origen === "datosNombre");
    console.debug(value)
    if(value.length > 0){
      if(value[0].propiedades?.a2DatosGenerales?.a2DatosCurpRfc?.rfc && value[0].propiedades?.a2DatosGenerales?.a2DatosCurpRfc?.curp
        && value[0].propiedades?.a2DatosGenerales?.a2DatosCorreo?.correoElectronico
        && value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.nombre && value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.primerApellido){
        this.userInfo = {
          name: `${value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.nombre} ${value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.primerApellido} ${value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.segundoApellido? value[0].propiedades?.a2DatosGenerales?.a2DatosGenerales?.segundoApellido : ""}`,
          email: value[0].propiedades?.a2DatosGenerales?.a2DatosCorreo?.correoElectronico,
          rfc: value[0].propiedades?.a2DatosGenerales?.a2DatosCurpRfc?.rfc,
          curp: value[0].propiedades?.a2DatosGenerales?.a2DatosCurpRfc?.curp
        }
      } else {
        this.validData = false;
      }
    } else {
      this.validData = false;
    }
  }

  ngOnInit() {
    this.buttonControlService.cambiarBotonSiguiente(false);
    this.registerForm = this.fb.group({
      contrasena: ['', Validators.compose([Validators.required, this.customValidator.patternValidator()])],
      contrasenaConfirma: ['', [Validators.required]],
    },
      {
        validator: this.customValidator.MatchPassword('contrasena', 'contrasenaConfirma'),
      }
    );
  }

  get registerFormControl() {
    if(this.valid !== this.registerForm.status){
      if("INVALID" === this.registerForm.status){
        this.errorGenerateCsr = false;
        this.buttonControlService.cambiarBotonSiguiente(false);
        this.errorGenerateCsr = false;
        this.showDownload = false;
      } else
      if("VALID" === this.registerForm.status){
        this.csrService.generateCSR(this.userInfo, this.registerForm.value.contrasena)
          .then(
              response => {
                if(response && response.key && response.req){
                  // this.buttonControlService.cambiarBotonSiguiente(true);
                  // this.setChanges(response);
                  this.errorGenerateCsr = false;
                  this.isDownload = false;
                  this.showDownload = true;
                  this.cer = response;
                } else {
                  this.errorGenerateCsr = true;
                  this.showDownload = false;
                }
              }
          ).catch((e) => this.errorGenerateCsr = true);
      }
      this.valid = this.registerForm.status;
    }
    return this.registerForm.controls;
  }

  descragar(){
    this.isDownload = true;
    this.buttonControlService.cambiarBotonSiguiente(true);
    const name = uuid.v4();
    const linkSource = "data:application/pkcs8;base64," + btoa(this.cer.key);
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = `${name}.key`;
    downloadLink.click();
    downloadLink.remove();

    const linkSourceReq = "data:application/x-x509-ca-cert;base64," + btoa(this.cer.req);
    const downloadLinkReq = document.createElement("a");
    downloadLinkReq.href = linkSourceReq;
    downloadLinkReq.download = `${name}.req`;
    downloadLinkReq.click();
    downloadLinkReq.remove();

    this.setChanges({
      req: btoa(this.cer.req),
      isDownload: this.isDownload,
    });
  }

  setChanges(values) {
    const response: EvkSeccionModel = {
        origen: this.config.nombre,
        propiedades: values,
    };
    this.datosSeccionWizard.doneSave(response);
  }

  onSubmit() {
    this.submitted = true;
  }

}
